import { render, staticRenderFns } from "./TabelaParametros.vue?vue&type=template&id=7f3e34f2&"
import script from "./TabelaParametros.vue?vue&type=script&lang=js&"
export * from "./TabelaParametros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports